import React, { useState, useContext } from "react";
import { renderStatementWithKaTeX } from "../../../../../Functions/WriteLaTex";
import { useNavigate, useParams } from "react-router-dom";
import "./AddProblemToUnit.css";
import { AuthContext } from "../../../../../context/authContext";
import API from "../../../../../Functions/API/api";

const AddProblemToUnit = () => {
  const [problemStatement, setProblemStatement] = useState("");
  const [ProblemField, setProblemField] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [source, setSource] = useState("");
  const [hints, setHints] = useState([]); // committed hints
  const [hintInput, setHintInput] = useState(""); // current hint input

  const { user } = useContext(AuthContext);
  const { unitId } = useParams();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload
    try {
      const payload = {
        referenceCode: `U-${ProblemField[0]}-${Date.now()}`, // unique code
        difficulty,
        statement: problemStatement,
        field: ProblemField,
        source,
        solution: "",
        author: user?.username,
        hints,
      };

      const res = await API.post(
        `/unit/${unitId}/problems`,
        payload
      );

      console.log("Problem added:", res.data);
      alert("✅ Problem added successfully!");
      window.location.reload(); // reload the page
    } catch (err) {
      console.error(err);
      alert("❌ Failed to add problem");
    }
  };

  // ------- HINT HANDLERS -------
  const addHint = () => {
    const val = hintInput.trim();
    if (!val) return;
    setHints([...hints, val]);
    setHintInput("");
  };
  const removeHint = (i) => setHints(hints.filter((_, idx) => idx !== i));

  return (
    <div className="AddProblem-container">
      <h2 className="AddProblem-heading" style={{ color: "#9a0002" }}>
        🔍 Add new Problem to this unit
      </h2>

      <form className="AddProblem-content" onSubmit={handleSubmit}>
        {/* Difficulty + Field + Source */}
        <div className="AddProblem-tags">
          <h2>- Field :</h2>
          <select
            value={ProblemField}
            onChange={(e) => setProblemField(e.target.value)}
            className="AddProblem-difficulty"
            required
          >
            <option value="" disabled>
              Select Field
            </option>
            <option value="Algebra">Algebra</option>
            <option value="Geometry">Geometry</option>
            <option value="NumberTheory">Number Theory</option>
            <option value="Combinatorics">Combinatorics</option>
          </select>

          <h2>- Difficulty :</h2>
          <select
            value={difficulty}
            onChange={(e) => setDifficulty(e.target.value)}
            className={`AddProblem-difficulty ${difficulty}`}
            required
          >
            <option value="" disabled>
              Select difficulty
            </option>
            <option value="Easy">Easy</option>
            <option value="Medium">Medium</option>
            <option value="Hard">Hard</option>
          </select>

          <h2>- Source :</h2>
          <div className="tags-row">
            <input
              value={source}
              className="tag-input"
              type="text"
              placeholder="Include source ..."
              onChange={(e) => setSource(e.target.value)}
              required
            />
          </div>
        </div>

        {/* Problem Statement */}
        <label className="section-label">Problem Statement :</label>
        <div className="AddProblem-title">
          {renderStatementWithKaTeX(problemStatement)}
        </div>
        <textarea
          className="ProblemStatementFillUp"
          value={problemStatement}
          onChange={(e) => setProblemStatement(e.target.value)}
          required
        />

        {/* Problem Hints */}
        <label className="section-label">Problem Hints :</label>
        {hints.map((hint, i) => (
          <div key={i} className="hint-box">
            <p>{hint}</p>
            <button
              type="button"
              className="hint-remove"
              onClick={() => removeHint(i)}
            >
              ×
            </button>
          </div>
        ))}
        <div className="hints-row">
          <input
            className="hint-input"
            type="text"
            value={hintInput}
            placeholder="Add hint"
            onChange={(e) => setHintInput(e.target.value)}
            onKeyDown={(e) =>
              e.key === "Enter" && (e.preventDefault(), addHint())
            }
          />
          <button
            type="button"
            className="add-hint"
            onClick={addHint}
          >
            +
          </button>
        </div>

        {/* Submit */}
        <div className="AddProblem-buttons-conatiner">
          <button className="AddProblem-button-SC" type="submit">
            Add Problem
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddProblemToUnit;
